<template>
  <div no-gutters class="base-view">
    <div class="header">
      <slot name="header" />
    </div>
    <div class="scrollable-content" @scroll="onScroll">
      <slot name="content" />
    </div>
    <slot name="snackbar" />
    <div class="action">
      <slot name="action" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseView",
  props: {
    onScroll: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    showMainButton() {
      return this.onMainButtonPressed != null;
    },
  },
};
</script>

<style scoped>
.base-view {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 170px);
  overflow: hidden;
  background-color: var(--color-bg);
  padding: 10px;
  gap: 20px;
}

.header {
  flex-shrink: 0;
}

.action {
  flex-shrink: 0;
}

.scrollable-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
